<template>
  <div>
    <!-- Form -->
    <v-container grid-list-md>
      <v-flex xs12>
        <v-card>
          <v-card-title>
            <span class="title">{{ formTitle }}</span>
          </v-card-title>
          <!-- {{catList}} -->
          <v-form v-model="valid" ref="form" lazy-validation>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm6 md4 class="pr-4">
                    <v-autocomplete
                      label="Category Name *"
                      item-text="cat_name"
                      item-value="id"
                      v-model="formSchema.cat_id"
                      :items="catList"
                      :rules="[v => !!v || 'Field is required']"
                    ></v-autocomplete>
                  </v-flex>

                  <v-flex xs12 sm6 md4 class="pr-4">
                    <v-text-field
                      label="Sub Category Name *"
                      v-model="formSchema.sub_cat_name"
                      :rules="[v => !!v || 'Field is required']"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md4 sm3>
                    <v-checkbox
                      v-model="formSchema.is_active"
                      label="Active"
                      :value="isActiveVal"
                    ></v-checkbox>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                class="success"
                flat
                v-if="userRole.saveButton || userRole.updateButton"
                @click.native="validateBeforeSubmit"
              >
                <v-icon>save</v-icon>
                {{ buttonTitle }}
              </v-btn>
              
              <v-btn class="info" flat @click.native="close({message:'Form Reseted !',status:1})">
                <v-icon>refresh</v-icon>Reset
              </v-btn>
              
            </v-card-actions>
          </v-form>
        </v-card>
      </v-flex>
    </v-container>
    <!-- /Form -->
  </div>
</template>


<script>
let commonService = require("../../../services/common.service");

export default {
  props: ["formSchema"],

  data: () => ({
    valid: true,
    isActiveVal: 1,
    roleList: [],
    catList: []
  }),

  computed: {
    formTitle() {
      return this.formSchema.id > 0
        ? "Edit Asset Sub Category"
        : "Add Asset Sub Category";
    },
    buttonTitle() {
      return this.formSchema.id > 0 ? "Update" : "Save";
    },

    // User Previlization methods
    userRole() {
      return this.$store.getters.get_USER_ROLE_DATA;
    }
  },

  created() {
    let root = this;
    commonService.getAllData("get-role-list").then(res => {
      root.roleList = res.roleList;
    });

    commonService.getAllData("get_asset_cat_info").then(res => {
      root.catList = res.data;
    });
  },

  methods: {
    validateBeforeSubmit(e) {
      var formSchema = this.formSchema;

      var root = this;
      if (root.$refs.form.validate()) {
        if (formSchema.id > 0) {
          commonService
            .updateFormData(this.formSchema, "asset_sub_category")
            .then(res => {
              res.action = "edit";
              this.close(res);
            });
        } else {
          commonService
            .insertFormData(this.formSchema, "asset_sub_category")
            .then(res => {
              res.action = "add";
              this.close(res);
            });
        }
      }
    },

    // close: function Perform
    close: function(data) {
      if (data.status == 1) {
        this.$refs.form.reset();
        this.formSchema.id = 0;
      }
      this.$emit("emitForm", data);
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/asset/asset_sub_category/asset_sub_cat_form.vue